import { jsonGet } from '../components/ajax';
import { API_REFERENCE } from './constant_api';
import { colorBoxCloseIdText } from './constant_config';
import { getvariableValue } from './utility';

const checkoutPageRedirectUrl = {
  accountInformation: API_REFERENCE.checkoutAccount.getProfile,
  deliveryAddress: API_REFERENCE.checkoutAddress.viewAddress,
  insurance: API_REFERENCE.checkoutInsurance.insurancePageReload,
  physician: API_REFERENCE.checkoutPhysician.viewPhysicians,
  actionItems: API_REFERENCE.checkoutActionItem.viewActionItem,
  paymentMethod: API_REFERENCE.checkoutPaymentMethods.viewPaymentMethod,
  diagnosis: API_REFERENCE.checkoutDiagnosis.navigateHealthCondition,
  deliveryMethod: API_REFERENCE.checkoutShippingMethod.navigateToShippingMethod
};
const defaultButtonAriaLabelText = 'button-element';

function navigateUrlFormation(dataCheckoutStep) {
  window.location.replace(
    `${ACC.config.encodedContextPath}${checkoutPageRedirectUrl[dataCheckoutStep]}`
  );
}

export function reloadProfilePage(e) {
  e.preventDefault();
  const $this = $(this);
  const loactionVariableName = location.pathname;
  const dataCheckoutStep = $this.attr('data-checkout-step');
  const toggleImg = $this.find('.checkout-accordian__icon');
  toggleImg.addClass(
    'svg-icon_circle_minus_blue svg-icon_circle_minus_blue-dims'
  );
  if (
    loactionVariableName.indexOf('action-items') > 0 ||
    loactionVariableName.indexOf('diagnosis') > 0
  ) {
    const checkoutFormForSessionStorage = getvariableValue(
      'checkoutFormForSessionStorage'
    );
    if (
      checkoutFormForSessionStorage !== undefined &&
      checkoutFormForSessionStorage.length > 0
    ) {
      $('input[name=checkoutStepNavigator]').val(
        checkoutPageRedirectUrl[dataCheckoutStep]
      );
      checkoutFormForSessionStorage.submit();
      return true;
    }
  }
  navigateUrlFormation(dataCheckoutStep);
}

export function isButtonEmpty() {
  let buttonAriaLabelText;
  let $thisEle;
  let thisEleId;
  let dataDismissEle;
  $('button')
    .not('[aria-label]')
    .each((index, element) => {
      $thisEle = $(element);
      thisEleId = $thisEle.attr('id');
      dataDismissEle = $thisEle.attr('data-dismiss');
      buttonAriaLabelText =
        $thisEle.attr('name') ||
        thisEleId ||
        dataDismissEle ||
        defaultButtonAriaLabelText;
      if (
        $thisEle.text() === '' ||
        thisEleId === colorBoxCloseIdText ||
        dataDismissEle !== undefined ||
        $thisEle.find('img, span, div').length
      ) {
        if (!$thisEle.hasClass('accountHeaderText')) {
          $thisEle.attr('aria-label', buttonAriaLabelText);
        }
      }
    });
}

export function openSignInModal() {
  $('.header-signin')[0].click();
}

export function validateCartPage(clsButtonClass, dropdownLength) {
  $(dropdownLength).selectmenu({
    change() {
      let supplyPeriodEmptyFlag = false;
      let selectedval;
      const $supplyPeriodEle = $(dropdownLength);
      if ($supplyPeriodEle.length > 0) {
        $supplyPeriodEle.each(function() {
          selectedval = $(this)
            .find(':selected')
            .text();
          if (selectedval === '') {
            supplyPeriodEmptyFlag = true;
            return false;
          }
        });
      }
      $(clsButtonClass).prop('disabled', supplyPeriodEmptyFlag);
    }
  });
}

export function populatePage(productCode, dropdown) {
  let overrideReasonText = '';
  const overrideDropdown = dropdown;
  const codeQuery = $.trim(productCode);
  const overrideReasonsUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutActionItems.getOverrideReasons}?productCode=${codeQuery}`;
  jsonGet(overrideReasonsUrl).then(data => {
    data.forEach(selection => {
      const overrideReasonOption = $('<option>', {
        value: selection
      });
      if (overrideReasonOptions.hasOwnProperty(selection)) {
        overrideReasonText = overrideReasonOptions[selection];
        $(overrideReasonOption).append(overrideReasonText);
        $(overrideDropdown).append(overrideReasonOption);
      }
    });
  });
}

export function selectmenuAccessibilityCompliance() {
  setTimeout(function() {
    $('.ui-selectmenu-button')
      .prev('select')
      .selectmenu('refresh');
  }, 250);
  $('.ui-selectmenu-button').each(function() {
    const selectmenuAriaLabelText = $(this)
      .prev()
      .attr('aria-label');
    const selectmenuLabelledBy = $(this)
      .prev()
      .attr('aria-labelledby');
    const selectmenuDescribedbyId = $(this)
      .prev()
      .attr('id');
    $(this).attr('aria-label', selectmenuAriaLabelText);
    $(this).attr('role', 'listbox');
    $(this)
      .children()
      .attr('role', 'option');
    $(this).removeAttr('aria-autocomplete');
    if (selectmenuDescribedbyId !== undefined) {
      $(this).attr('aria-describedby', selectmenuDescribedbyId);
    }
    $(this).on('focus', function() {
      $(this).attr(
        'aria-labelledby',
        selectmenuLabelledBy !== undefined
          ? selectmenuLabelledBy
          : selectmenuAriaLabelText
      );
    });
  });
}

export function skipToAccessibleContent() {
  const $mainContentBlock = $('.main__inner-wrapper');
  const $searchFilterElement = $mainContentBlock.find(
    '.search-refine__filter-reset a'
  );
  const $isCartPage = $('.cart-page-logged');
  const $isCartPageLoggedout = $('.container-fluid.product-detail.cart');
  const $isCheckoutPage = $('.product-section-desc-col');
  const $searchFilterSection = $('#product-facet');
  const $breadcrumbElement = $('.global-breadcrumb');
  const $homePage = $('.home-container');
  const $isOrderConfirmation = $('.order-confirmation__title');
  const $isMfaPage = $('.mfa-outer-container');
  const isHttpErrorPage = $('.error-page');
  if ($searchFilterSection.length && $searchFilterSection.is(':visible')) {
    $searchFilterElement.attr('id', 'skip-to-content');
  } else if ($('.breadcrumb').length && $('.breadcrumb').is(':visible')) {
    const $breadcrumbActiveLink = $breadcrumbElement.find(
      'ol:not(".hidden") li.active a'
    );
    $breadcrumbElement
      .find('ol:not(".hidden") li:eq(0)')
      .attr('id', 'skip-to-content');
    $breadcrumbElement
      .find('ol:not(".hidden") li.active a')
      .attr('aria-label', `current link ${$breadcrumbActiveLink.text()}`);
  } else if ($isCartPage.length && $isCartPage.is(':visible')) {
    $isCartPage
      .find('.js-continue-checkout-button')
      .attr('id', 'skip-to-content');
  } else if ($homePage.length && $homePage.is(':visible')) {
    $homePage.find('.home-hero-banner a').attr('id', 'skip-to-content');
  } else if ($isCheckoutPage.length && $isCheckoutPage.is(':visible')) {
    $isCheckoutPage
      .find('.checkoutPageList:eq(0)')
      .attr('id', 'skip-to-content');
    $('.page-multiStepCheckoutSummaryPage')
      .find('#skiptonavigation')
      .removeAttr('id');
    $('.page-multiStepCheckoutSummaryPage')
      .find('.logoForCheckout')
      .attr('id', 'skiptonavigation');
  } else if (
    $isOrderConfirmation.length &&
    $isOrderConfirmation.is(':visible')
  ) {
    $isOrderConfirmation
      .find('.order-confirmation__title-print')
      .attr('id', 'skip-to-content');
  } else if ($isMfaPage.length) {
    $isMfaPage.attr('id', 'skip-to-content');
  } else if (isHttpErrorPage.length) {
    isHttpErrorPage
      .find('.error-page__para')
      .first()
      .find('.error-page__link')
      .attr('id', 'skip-to-content');
  } else if (
    $isCartPageLoggedout.length &&
    $isCartPageLoggedout.is(':visible')
  ) {
    $isCartPageLoggedout
      .find('.js-continue-checkout-button')
      .attr('id', 'skip-to-content');
  }
}

export function makeDatepickerAccessible(
  focusEle = null,
  onBlurPreviousEle = null,
  datepickerEle = null
) {
  const $datepickerElement = $('#ui-datepicker-div');
  if ($('#previousNextDatepickerClicked').length <= 0) {
    $('<input>')
      .attr({ type: 'hidden', id: 'previousNextDatepickerClicked' })
      .appendTo('body');
  }
  setTimeout(() => {
    $datepickerElement
      .find('.ui-datepicker-prev, .ui-datepicker-next')
      .attr('href', 'javascript:void(0)')
      .attr('title', '');
    $datepickerElement.find('a').attr('role', 'button');
    $datepickerElement.find('.ui-datepicker-prev').focus();
    if (focusEle !== null) {
      const lastRowCell =
        '#ui-datepicker-div .ui-datepicker-calendar tbody tr:last td:not(".ui-state-disabled")';
      const $lastCellItems = $(lastRowCell).length;
      $(document).on(
        'blur',
        `${lastRowCell}:eq(${$lastCellItems - 2})`,
        function() {
          focusEle.focus();
          $('.hasDatepicker').datepicker('hide');
        }
      );
    }
  }, 500);
  if (onBlurPreviousEle !== null && datepickerEle !== null) {
    $(document).on('keydown blur', '.ui-datepicker-prev', function(e) {
      if (e.which === 9 && e.shiftKey) {
        onBlurPreviousEle.focus();
        datepickerEle.datepicker('hide');
        return false;
      }
    });
  }
}

export function setFocusOnPreviousNextButton(selectedMonthVal) {
  let todayDate = new Date();
  let prevDatepickerEle = 'ui-datepicker-prev';
  let nextDatepickerEle = 'ui-datepicker-next';
  setTimeout(() => {
    $(`.${prevDatepickerEle}, .${nextDatepickerEle}`).attr('href', '#');
    if (
      $(dynamicHiddenFieldEle).length > 0 &&
      $(dynamicHiddenFieldEle).val() !== ''
    ) {
      $(`.${$(dynamicHiddenFieldEle).val()}`).focus();
    } else {
      if (todayDate.getMonth() + 1 < selectedMonthVal) {
        $(dynamicHiddenFieldEle).val(prevDatepickerEle);
      } else {
        $(dynamicHiddenFieldEle).val(nextDatepickerEle);
      }
    }
  }, 100);
  $(document).on(
    'click',
    `.${prevDatepickerEle}, .${nextDatepickerEle}`,
    function(event) {
      event.preventDefault();
      if ($(dynamicHiddenFieldEle).length !== 0) {
        if ($(event.target).hasClass(nextDatepickerEle)) {
          $(dynamicHiddenFieldEle).val(prevDatepickerEle);
        } else {
          $(dynamicHiddenFieldEle).val(nextDatepickerEle);
        }
      }
    }
  );
}

export function removeDynamicHiddenField() {
  if ($(dynamicHiddenFieldEle).length != 0) {
    $(dynamicHiddenFieldEle).remove();
  }
}
